import { loadScript } from "utils/dom/load-script";

const CACHE: {
  loader?: Promise<void>;
} = {};

export async function loadGooglePlacesApi() {
  if (!CACHE.loader) {
    CACHE.loader = new Promise((resolve, reject) => {
      window.initGoogleMaps = () => {
        resolve();
      };

      void loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${
          import.meta.env.VITE_GOOGLE_PLACES_API_KEY
        }&callback=initGoogleMaps&language=en&libraries=places&loading=async`,
      ).catch(reject);
    });
  }

  await CACHE.loader;
}
